var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row d-flex flex-column-reverse flex-lg-row h-100" },
    [
      _c(
        "div",
        { staticClass: "col-lg-6 col-md-12 mt-md-1 mt-n5 z-index-2" },
        [
          _c("h2", { staticClass: "page-heading" }, [
            _vm._v(_vm._s(_vm.translations.partners))
          ]),
          _vm._v(" "),
          _c("data-selectors", {
            attrs: { locale: _vm.locale, translations: _vm.translations }
          }),
          _vm._v(" "),
          _c("accordion", {
            attrs: { locale: _vm.locale, translations: _vm.translations }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-6 col-md-12 mapa-vlnka mt-0" },
        [
          _c("partners-google-map", {
            attrs: { apikey: this.apikey, localization: _vm.locale }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }